import { render, staticRenderFns } from "./MarketplaceWishlist.vue?vue&type=template&id=10f4d286&"
import script from "./MarketplaceWishlist.vue?vue&type=script&lang=js&"
export * from "./MarketplaceWishlist.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceWishlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports